module.exports = __webpack_public_path__ + "static/media/services-left-image.ae484a9b.png";